<template>
  <div class="row collapsible-body">
    <h4 class="header col s12 light">Réserver mes billets</h4>

    <form class="col s12" autocomplete="off">
      <div class="input-field col s12 l4">
        <InputCity name="departure" text="ville de départ" selected="MA" v-model="departure" />
        <label for="departure">Départ</label>
      </div>

      <div class="input-field col s12 l4">
        <InputCity name="destination" text="ville d'arrivée" selected="AN" v-model="destination" />
        <label for="destination">Arrivée</label>
      </div>

      <div class="input-field col s6 l2">
        <InputDateTravel id="date" from="departure" to="destination" mindate="" v-model="date" />
        <label for="date">Aller</label>
      </div>

      <div class="input-field col s6 l2 scale-transition">
        <InputDateTravel id="datereturn" from="destination" to="departure" :mindate="date" v-model="datereturn" />
        <label for="datereturn">Retour</label>
      </div>

      <div class="input-field col s6 l4">
        <InputNumber v-model="place" />
        <label for="place" class="active">nombre de billets</label>
      </div>

      <div class="input-field col s6 l4 center" style="margin-top: 25px">
        <div class="switch">
          <label>
            aller-retour
            <input type="checkbox" checked="checked" name="allerouretour" />
            <span class="lever"></span>
          </label>
        </div>
      </div>

      <div class="input-field col s12 l4 center">
        <a id="validTravel" class="waves-effect waves-light btn disabled">Réserver</a>
      </div>
    </form>

    <div>
      <span id="prices"></span>
      <span id="dispos"></span>
    </div>
    <div style="text-align: center; color: #f65aa5; font-weight: bold;">
      <span id="disposWarning"></span>
    </div>

  </div>
</template>

<script>
import InputNumber from "@/components/reservation/InputNumber.vue";
import InputCity from "@/components/reservation/InputCity.vue";
import InputDateTravel from "@/components/reservation/InputDateTravel.vue";

import axios from "axios";
import M from "materialize-css";
import jquery from "jquery";
import API from "../api.js";

export default {
  components: {
    InputNumber,
    InputCity,
    InputDateTravel,
  },
  data() {
    return {
      departure: "",
      destination: "",
      place: 1,
      date: null,
      datereturn: null,
      codedate: null,
      codedatereturn: null,
      seats_codedate: null,
      seats_codedatereturn: null,
      isButtonDisabled: false,
    };
  },
  mounted() {
    // validate travel
    jquery("#validTravel").on(
      "click",
      function () {
        this.emitData();
        var instance = M.Collapsible.getInstance(jquery(".collapsible"));
        instance.open(1);
        jquery("html, body").animate({ scrollTop: 0 }, "slow");
      }.bind(this)
    );

    // show/hide return date
    jquery('input[name="allerouretour"]').on(
      "click",
      function () {
        let checked = jquery('input[name="allerouretour"]').prop("checked");
        jquery("#datereturn")
          .parent()
          .animate({ opacity: checked ? 1 : 0 }, 200);

        this.codedatereturn = null;
        this.datereturn = null;
        this.seats_codedatereturn = null;
        this.showDispos();
      }.bind(this)
    );

    // Receive extra codeTravel & codeTravelReturn
    this.$root.$on("codedate", (data) => {
      this["seats_" + data.name] = data.seats;
      this[data.name] = data.code;
      this.showDispos();
    });
  },
  watch: {
    $data: {
      handler() {
        this.emitData();
        this.updatePrices();
        //this.updateDispos();
      },
      deep: true,
    },
  },
  methods: {
    updatePrices() {
      if (this.destination && this.departure && this.place && this.date) {
        console.log(this.date);

        let dateleave = this.date.split("/").reverse().join("-");
        let datereturn = this.datereturn
          ? this.datereturn.split("/").reverse().join("-")
          : "";

        Promise.all([
          axios.get(API.prices, {
            params: {
              destination: this.destination,
              departure: this.departure,
              date_leave: dateleave,
              date_return: datereturn,
              type: "A", // adultes
            },
          }),
          axios.get(API.prices, {
            params: {
              destination: this.destination,
              departure: this.departure,
              date_leave: dateleave,
              date_return: datereturn,
              type: "E", // enfants
            },
          }),
          axios.get(API.prices, {
            params: {
              destination: this.destination,
              departure: this.departure,
              date_leave: dateleave,
              date_return: datereturn,
              type: "B", // bébés
            },
          }),
        ]).then((resp) => {
          let prices = resp[0].data.prices
            .concat(resp[1].data.prices)
            .concat(resp[2].data.prices);

          prices.length ? this.showPrices(prices) : this.hidePrices();
        });
      } else {
        this.hidePrices();
      }
    },

    formatPriceTitle(price) {
      switch (price) {
        case "A": return "Adulte";
        case "E": return "Enfant";
        case "B": return "Bébé";
      }
    },

    showPrices(prices) {
      let text = [];

      for (let i = 0; i < prices.length; i++) {
        text.push(
          this.formatPriceTitle(prices[i].typeTarif) + " " + prices[i].amount + "€"
        );
      }

      // Certainement à revoir : on n'enregistre que le premier tarif (Adulte, ou Bébé, ou Enfant)
      // finalement, code représente le codeAller (et codereturn le codeRetour)
      //this.code = prices[0].codeTarif;

      jquery(this.$el)
        .find("#prices")
        .html("TARIFS : " + text.join(", "))
        .animate({ opacity: 1 });
      //document.querySelector("#validTravel").classList.remove("disabled");

    },

    hidePrices() {
      jquery(this.$el).find("#prices").animate({ opacity: 0.1 }).html("");
      //document.querySelector("#validTravel").classList.add("disabled");
    },

    showDispos() {

      const dispos =
        "<br/>PLACES DISPONIBLES&nbsp;:&nbsp;"
        +
        (this.seats_codedate != null
          ? `${this.seats_codedate} places`
          + (this.seats_codedatereturn != null ? ' aller' : '')
          : '')
        +
        (this.seats_codedatereturn != null
          ? `, ${this.seats_codedatereturn} places retour`
          : '')

      jquery(this.$el)
        .find("#dispos")
        .html(this.seats_codedate != null ? dispos : '')
        .animate({ opacity: 1 });

      this.updateButtonState(); // Appelez cette méthode pour mettre à jour l'état du bouton

    },

    emitData() {
      this.$root.$emit(
        "emit-travel",
        this.departure,
        this.destination,
        this.place,
        this.date,
        this.datereturn,
        this.codedate,
        this.codedatereturn,
        this.code
      );
    },

    // compareDates(date1, date2) {
    //   const [day1, month1, year1] = date1.split('/').map(Number);
    //   const [day2, month2, year2] = date2.split('/').map(Number);

    //   const dateObj1 = new Date(year1, month1 - 1, day1);
    //   const dateObj2 = new Date(year2, month2 - 1, day2);

    //   return dateObj1 - dateObj2;
    // },

    updateButtonState() {


      let warningMessage = '';

      if (this.seats_codedate !== null) { // VERIFICATION SI IL Y A UNE DATE CHOISI A L ALLE
        if (this.seats_codedatereturn !== null) { // VERIFICATION SI IL Y A UNE DATE CHOISI AU RETOUR
          if (this.seats_codedate < 1 || this.seats_codedatereturn < 1) {
            warningMessage += `<br/><span>AUCUNE PLACE DISPONIBLE POUR CETTE DATE.</span>`;
          } else if (this.seats_codedate < 20 || this.seats_codedatereturn < 20) {
            warningMessage += `<br/><span>RESERVATION IMPOSSIBLE POUR CETTE DATE : Veuillez contacter l'agence ou choisir une autre date.</span>`;
          }
        } else {
          if (this.seats_codedate < 1) { // VERIFICATION SI LA DATE ALLE A MOINS DE 1 PLACE (si le client juste choisi l'alle)
            warningMessage += `<br/><span>AUCUNE PLACE DISPONIBLE POUR CETTE DATE.</span>`;
          } else if (this.seats_codedate < 20) { // VERIFICATION SI LA DATE ALLE A MOINS DE 20 PLACES (si le client juste choisi l'alle)
            warningMessage += `<br/><span>RESERVATION IMPOSSIBLE POUR CETTE DATE : Veuillez contacter l'agence ou choisir une autre date.</span>`;
          }
        }
      }

      // console.log("Log date return:" + this.datereturn);
      // console.log("Log date alle:" + this.date);

      // if (this.date.length>1 && this.datereturn.length>1) {
      //   if(this.compareDates(this.datereturn, this.date)<0){
      //     warningMessage += `<br/><span class="red-text">Réservation impossible : La date retour ne pas être avant la date allé.</span>`;
      //   }else{
      //     warningMessage += `<br/><span class="red-text">Réservation impossible : La date retour ne pas être avant la date allé222.</span>`;
      //   }
      // }

      if (warningMessage || this.seats_codedate == null) {
        document.querySelector("#validTravel").classList.add("disabled");
      } else document.querySelector("#validTravel").classList.remove("disabled");

      jquery(this.$el)
        .find("#disposWarning")
        .html(warningMessage)
        .animate({ opacity: 1 });

    },

  },
};
</script>


<style scoped>
.collapsible-body {
  background-color: white;
  margin-top: 105px;
  margin-bottom: 0;
  color: rgba(0, 0, 0, 0.87);
}

#prices {
  opacity: 0.1;
  text-decoration: underline;
}

#dispos {
  font-weight: bold;
  text-decoration: underline;
}
</style>